import React, { useState, useEffect, useRef } from "react";
import { buildApiUrl, getApiUrl } from '../config/api';

// --- SVG ICONS (Themed for Admin Panel) ---
const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-3"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
    />
  </svg>
);
const ArticleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-3"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
);
const VideoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-3"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
    />
  </svg>
);
const ShortsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-3"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
    />
  </svg>
);
const NewspaperIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-3"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3h2m0 3h2"
    />
  </svg>
);
const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-3"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
    />
  </svg>
);
const ViewIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    />
  </svg>
);
const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

const EyeIcon = ({ open }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <linearGradient id="gOpen" x1="0" x2="1" y1="0" y2="1">
        <stop offset="0%" stopColor="#FBBF24" />
        <stop offset="100%" stopColor="#EF4444" />
      </linearGradient>
      <linearGradient id="gClosed" x1="0" x2="1" y1="0" y2="1">
        <stop offset="0%" stopColor="#9CA3AF" />
        <stop offset="100%" stopColor="#6B7280" />
      </linearGradient>
      <filter id="eyeShadow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx="0" dy="1" stdDeviation="1" floodColor="#000" floodOpacity="0.12" />
      </filter>
    </defs>

    {open ? (
      <>
        <g filter="url(#eyeShadow)">
          <path
            d="M2.6 12s3.3-6.2 9.4-6.2S21.4 12 21.4 12s-3.3 6.2-9.4 6.2S2.6 12 2.6 12z"
            fill="none"
            stroke="url(#gOpen)"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.98"
          />
        </g>
        <circle
          cx="12"
          cy="12"
          r="3"
          fill="url(#gOpen)"
          stroke="#fff"
          strokeWidth="0.8"
        />
        <circle cx="13.1" cy="10.8" r="0.6" fill="rgba(255,255,255,0.9)" />
      </>
    ) : (
      <>
        <g filter="url(#eyeShadow)">
          <path
            d="M2.6 12c1.8-3.4 5.6-6.2 9.4-6.2 3.8 0 7.6 2.8 9.4 6.2-1.8 3.4-5.6 6.2-9.4 6.2-3.8 0-7.6-2.8-9.4-6.2z"
            fill="none"
            stroke="url(#gClosed)"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.98"
          />
        </g>

        {/* soft eyelid arc to give a polished closed look */}
        <path
          d="M4.5 9.2c2.6-1.9 6.4-3.2 11.5-0.8"
          fill="none"
          stroke="#374151"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.85"
        />

        {/* stylized slash with rounded ends and slight gradient */}
        <path
          d="M5 4.5l14 15"
          stroke="url(#gClosed)"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.95"
        />

        {/* subtle pupil shadow for depth */}
        <circle
          cx="12"
          cy="12"
          r="2.2"
          fill="#111827"
          opacity="0.08"
        />
      </>
    )}
  </svg>
);
const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-3"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
    />
  </svg>
);

// --- DatePicker Component ---
const DatePicker = ({ value, onChange, placeholder = "dd/mm/yyyy" }) => {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");
  const [viewYear, setViewYear] = useState(() => {
    const d = value ? parseDDMMYYYY(value) : new Date();
    return d.getFullYear();
  });
  const [viewMonth, setViewMonth] = useState(() => {
    const d = value ? parseDDMMYYYY(value) : new Date();
    return d.getMonth();
  });
  const ref = useRef();

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  function parseDDMMYYYY(str) {
    const parts = String(str).split("/");
    if (parts.length === 3) {
      const [dd, mm, yyyy] = parts.map((s) => parseInt(s, 10));
      if (!isNaN(dd) && !isNaN(mm) && !isNaN(yyyy)) return new Date(yyyy, mm - 1, dd);
    }
    const d = new Date(str);
    return isNaN(d.getTime()) ? new Date() : d;
  }

  function formatDDMMYYYY(date) {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  function handleInputChange(e) {
    const v = e.target.value;
    setInputValue(v);
    // allow manual typing; validate on blur
  }

  function handleBlur() {
    // Validate dd/mm/yyyy
    const parts = inputValue.split("/");
    if (parts.length === 3) {
      const [dd, mm, yyyy] = parts.map((p) => parseInt(p, 10));
      if (
        !isNaN(dd) && !isNaN(mm) && !isNaN(yyyy) &&
        dd >= 1 && dd <= 31 && mm >= 1 && mm <= 12 && yyyy > 1900
      ) {
        onChange(formatDDMMYYYY(new Date(yyyy, mm - 1, dd)));
        setViewYear(yyyy);
        setViewMonth(mm - 1);
        return;
      }
    }
    // If invalid, leave as-is but do not call onChange
  }

  const selectedDate = value ? parseDDMMYYYY(value) : null;

  const daysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();
  const firstDayIndex = (y, m) => new Date(y, m, 1).getDay();

  const weeks = [];
  const dim = daysInMonth(viewYear, viewMonth);
  let week = Array(7).fill(null);
  let dayCounter = 1;
  const startIndex = firstDayIndex(viewYear, viewMonth);
  for (let i = 0; i < startIndex; i++) week[i] = null;
  for (let i = startIndex; i < 7; i++) {
    week[i] = dayCounter++;
  }
  weeks.push(week);
  while (dayCounter <= dim) {
    const wk = Array(7).fill(null);
    for (let i = 0; i < 7 && dayCounter <= dim; i++) wk[i] = dayCounter++;
    weeks.push(wk);
  }

  return (
    <div className="relative" ref={ref}>
      <div className="flex items-center">
        <input
          type="text"
          className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
          placeholder={placeholder}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => setOpen(true)}
          onBlur={handleBlur}
        />
        <button
          type="button"
          onClick={() => setOpen((s) => !s)}
          className="ml-2 p-2 bg-yellow-100 rounded border hover:bg-yellow-200"
          aria-label="Toggle calendar"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3M3 11h18M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </button>
      </div>
      {open && (
        <div className="absolute z-50 mt-2 w-64 bg-white border rounded shadow-lg p-3 text-sm text-gray-800">
          <div className="flex items-center justify-between mb-2">
            <button
              type="button"
              onClick={() => {
                if (viewMonth === 0) {
                  setViewMonth(11);
                  setViewYear((y) => y - 1);
                } else setViewMonth((m) => m - 1);
              }}
              className="p-1 hover:bg-gray-100 rounded"
            >
              ‹
            </button>
            <div className="font-semibold">
              {new Date(viewYear, viewMonth).toLocaleString("default", { month: "long" })} {viewYear}
            </div>
            <button
              type="button"
              onClick={() => {
                if (viewMonth === 11) {
                  setViewMonth(0);
                  setViewYear((y) => y + 1);
                } else setViewMonth((m) => m + 1);
              }}
              className="p-1 hover:bg-gray-100 rounded"
            >
              ›
            </button>
          </div>
          <div className="grid grid-cols-7 gap-1 text-center text-xs text-gray-500">
            {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(d => (
              <div key={d} className="font-medium">{d}</div>
            ))}
          </div>
          <div className="grid grid-cols-7 gap-1 mt-2">
            {weeks.flat().map((d, idx) => {
              const isSelected = d && selectedDate && d === selectedDate.getDate() && viewMonth === selectedDate.getMonth() && viewYear === selectedDate.getFullYear();
              return (
                <button
                  key={idx}
                  type="button"
                  onClick={() => {
                    if (!d) return;
                    const picked = new Date(viewYear, viewMonth, d);
                    const formatted = formatDDMMYYYY(picked);
                    setInputValue(formatted);
                    onChange(formatted);
                    setOpen(false);
                  }}
                  className={`p-1 rounded ${d ? 'hover:bg-gray-100' : ''} ${isSelected ? 'bg-red-500 text-white' : 'text-gray-700'}`}
                  disabled={!d}
                >
                  {d || ''}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

// --- Simple formatter: convert *text* to <strong>text</strong> for preview in admin
const escapeHtml = (unsafe) => {
  if (!unsafe) return "";
  return String(unsafe)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

const convertStarsToHtml = (text) => {
  if (!text) return "";
  // Escape HTML first to avoid injection
  const escaped = escapeHtml(text);
  // Replace occurrences of *...* with <strong>...</strong>
  // Non-greedy match to support multiple occurrences
  const replaced = escaped.replace(/\*(.+?)\*/g, (m, p1) => `<strong>${p1}</strong>`);
  // Preserve newlines as <br /> for preview
  return replaced.replace(/\r?\n/g, "<br />");
};

// Convert stored HTML to plain text for editing (keeps newlines)
const htmlToPlainText = (html) => {
  if (!html) return "";
  try {
    const div = document.createElement("div");
    // Replace <br> and <br/> with newlines so editors see breaks
    const sanitized = String(html).replace(/<br\s*\/?>/gi, "\n");
    div.innerHTML = sanitized;
    return div.textContent || div.innerText || "";
  } catch (e) {
    // Fallback: strip tags with regex (best-effort)
    return String(html).replace(/<[^>]*>/g, "").replace(/\r?\n/g, "\n");
  }
};

// Convert stored HTML into editor-friendly plain text using *stars* for bold.
// This preserves emphasis while removing raw tags from the textarea.
const htmlToEditorText = (html) => {
  if (!html) return "";
  try {
    // Decode entities first
    const textarea = document.createElement("textarea");
    textarea.innerHTML = String(html);
    const decoded = textarea.value;

    // Use a DOM parse to walk nodes and convert <strong>/<b> to *stars*
    const container = document.createElement("div");
    container.innerHTML = decoded.replace(/<br\s*\/?>(?=>)?/gi, "\n");

    const walk = (node) => {
      if (node.nodeType === Node.TEXT_NODE) return node.nodeValue || "";
      if (node.nodeType === Node.ELEMENT_NODE) {
        const tag = node.tagName.toLowerCase();
        if (tag === "br") return "\n";
        if (tag === "strong" || tag === "b") {
          // wrap children with stars
          const inner = Array.from(node.childNodes).map(walk).join("");
          return `*${inner}*`;
        }
        // For other elements, just concatenate their children
        return Array.from(node.childNodes).map(walk).join("");
      }
      return "";
    };

    const result = walk(container);
    // Normalize multiple consecutive newlines and trim
    return result.replace(/\r?\n[ \t\r\n]+/g, "\n").trim();
  } catch (e) {
    // Fallback: try simple replacements
    return String(html)
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&")
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/<\s*(strong|b)[^>]*>(.*?)<\s*\/\s*\1>/gi, "*$2*")
      .replace(/<br\s*\/?>(?=>)?/gi, "\n")
      .replace(/<[^>]*>/g, "")
      .replace(/\r?\n[ \t\r\n]+/g, "\n").trim();
  }
};

// --- LOGIN & SIGNUP COMPONENTS ---
const Login = ({ onLogin, setNotification, onSwitch }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const res = await fetch(getApiUrl('LOGIN'), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, isAdmin: true }),
      });
      const data = await res.json();
      if (res.ok && data.success && data.user?.isAdmin) {
        setSuccess("Admin login successful!");
        localStorage.setItem("adminToken", data.token);
        onLogin(data.user);
      } else {
        setError(data.message || "Admin login failed");
      }
    } catch (err) {
      console.error("Admin Login API Error:", err);
      setError("Network error. Could not connect to the server.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
      <div className="text-center mb-0 w-full flex justify-center">
        <div className="flex items-center justify-start w-full max-w-md">
          <img
            src="/logo1.png"
            alt="Logo"
            className="w-24 h-16 sm:w-40 sm:h-24 object-contain"
          />
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-yellow-600 leading-tight mb-0">
              AHMEDABAD POST
            </h1>
            <p className="text-gray-600 text-sm sm:text-base leading-tight mb-0">
              Admin Panel
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-md w-full bg-white p-6 sm:p-8 rounded-lg shadow-lg mt-0">
        <h2 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-6">
          Administrator Login
        </h2>
        <form onSubmit={handleAdminLogin}>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              id="email"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
              placeholder="e.g., master@amdavadpost.com"
              required
            />
          </div>
          <div className="mb-6">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <div className="relative">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                placeholder="******************"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword((s) => !s)}
                className="absolute right-2 top-2 text-gray-500 hover:text-gray-800"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                tabIndex={-1}
              >
                <EyeIcon open={showPassword} />
              </button>
            </div>
          </div>
          {error && <div className="text-red-600 text-sm mb-4">{error}</div>}
          {success && (
            <div className="text-green-600 text-sm mb-4">{success}</div>
          )}
          <div className="flex items-center justify-center">
            <button
              type="submit"
              className="w-full bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition-colors duration-300"
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </div>
        </form>
        <div className="mt-4 text-center">
          <span className="text-gray-600 text-sm">Not a user? </span>
          <button
            type="button"
            className="text-blue-600 hover:underline font-semibold text-sm"
            onClick={onSwitch}
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

const Signup = ({ onSwitch }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const res = await fetch(getApiUrl('SIGNUP'), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: name,
          email,
          password,
          isAdmin: true,
        }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSuccess("Signup successful! Please login.");
        if (data.token) {
          localStorage.setItem("adminToken", data.token);
        }
        setTimeout(() => {
          setSuccess("");
          onSwitch();
        }, 1500);
      } else {
        setError(data.message || "Signup failed");
      }
    } catch (err) {
      console.error("Admin Signup API Error:", err);
      setError("Network error. Could not connect to the server.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
      <div className="text-center mb-0 w-full flex justify-center">
        <div className="flex items-center justify-start w-full max-w-md">
          <img
            src="/logo1.png"
            alt="Logo"
            className="w-24 h-16 sm:w-40 sm:h-24 object-contain"
          />
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-yellow-600 leading-tight mb-0">
              AHMEDABAD POST
            </h1>
            <p className="text-gray-600 text-sm sm:text-base leading-tight mb-0">
              Admin Panel
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-md w-full bg-white p-6 sm:p-8 rounded-lg shadow-lg mt-0">
        <h2 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-6">
          Administrator Sign Up
        </h2>
        <form onSubmit={handleSignup}>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="name"
            >
              Username
            </label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
              placeholder="Your name"
              required
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
              placeholder="e.g., you@amdavadpost.com"
              required
            />
          </div>
          <div className="mb-6">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <div className="relative">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                placeholder="******************"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword((s) => !s)}
                className="absolute right-2 top-2 text-gray-500 hover:text-gray-800"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                tabIndex={-1}
              >
                <EyeIcon open={showPassword} />
              </button>
            </div>
          </div>
          {error && <div className="text-red-600 text-sm mb-4">{error}</div>}
          {success && (
            <div className="text-green-600 text-sm mb-4">{success}</div>
          )}
          <div className="flex items-center justify-center">
            <button
              type="submit"
              className="w-full bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition-colors duration-300"
              disabled={loading}
            >
              {loading ? "Signing Up..." : "Sign Up"}
            </button>
          </div>
        </form>
        <div className="mt-4 text-center">
          <span className="text-gray-600 text-sm">Already a user? </span>
          <button
            type="button"
            className="text-blue-600 hover:underline font-semibold text-sm"
            onClick={onSwitch}
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

// --- ADMIN PANEL COMPONENTS ---
const Sidebar = ({ user, currentPage, setCurrentPage, onLogout }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navItems = [
    { key: "dashboard", label: "Dashboard", icon: <DashboardIcon /> },
    { key: "articles", label: "Articles", icon: <ArticleIcon /> },
    { key: "users", label: "Users", icon: <UserIcon /> },
  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex w-64 bg-gray-800 text-white flex-col flex-shrink-0">
        <div className="h-20 flex items-center justify-center border-b border-gray-700 px-4">
          <img
            src="./logo.jpg"
            alt="Logo"
            className="w-40 h-16 object-contain p-0.5"
          />
        </div>
        <nav className="flex-grow">
          <ul>
            {navItems.map((item) => (
              <li key={item.key}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentPage(item.key);
                  }}
                  className={`flex items-center px-4 py-3 hover:bg-gray-700 transition-colors duration-200 ${
                    currentPage === item.key ? "bg-red-700" : ""
                  } text-white`}
                >
                  {item.icon}
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="border-t border-gray-700 p-4">
          <p className="text-sm text-gray-400">Logged in as:</p>
          <p className="font-semibold break-words">{user.username}</p>
          <p className="text-xs bg-yellow-500 text-gray-900 font-bold inline-block px-2 py-0.5 rounded-full mt-1 break-all">
            {user.email}
          </p>
          <button
            onClick={() => onLogout()}
            className="w-full mt-4 flex items-center justify-center text-sm bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition-colors duration-300"
          >
            <LogoutIcon />
            Logout
          </button>
        </div>
      </aside>

      {/* Mobile Header with Hamburger */}
      <div className="md:hidden flex items-center justify-between bg-gray-800 text-white px-4 py-3 border-b border-gray-700 sticky top-0 z-20">
        <div className="flex items-center">
          <img
            src="./logo.jpg"
            alt="Logo"
            className="w-28 h-10 object-contain"
          />
          <span className="ml-2 font-bold text-yellow-500 text-lg">ADMIN</span>
        </div>
        <button
          className="p-2 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white rounded"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Open menu"
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
            />
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden absolute top-16 left-0 w-full bg-gray-900 z-50 shadow-lg">
          <nav>
            <ul>
              {navItems.map((item) => (
                <li key={item.key}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentPage(item.key);
                      setMenuOpen(false);
                    }}
                    className={`flex items-center px-6 py-4 border-b border-gray-800 hover:bg-gray-700 transition-colors duration-200 ${
                      currentPage === item.key ? "bg-red-700" : ""
                    } text-white`}
                  >
                    {item.icon}
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div className="p-4 border-t border-gray-800">
            <p className="text-sm text-gray-400">Logged in as:</p>
            <p className="font-semibold break-words">{user.username}</p>
            <p className="text-xs bg-yellow-500 text-gray-900 font-bold inline-block px-2 py-0.5 rounded-full mt-1 break-all">
              {user.email}
            </p>
            <button
              onClick={() => onLogout()}
              className="w-full mt-4 flex items-center justify-center text-sm bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition-colors duration-300"
            >
              <LogoutIcon />
              Logout
            </button>
          </div>
        </div>
      )}
    </>
  );
};

const Dashboard = ({ stats, articles, allUsers }) => {
  const StatCard = ({ title, value, icon }) => (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md flex items-center">
      <div className="p-3 bg-yellow-100 rounded-full mr-4">{icon}</div>
      <div>
        <p className="text-sm text-gray-500 font-medium">{title}</p>
        <p className="text-2xl sm:text-3xl font-bold text-gray-800">{value}</p>
      </div>
    </div>
  );

  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6">
        Dashboard
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        <StatCard
          title="Total Articles"
          value={stats.articles}
          icon={<ArticleIcon />}
        />
        <StatCard
          title="Total Videos"
          value={stats.videos}
          icon={<VideoIcon />}
        />
        <StatCard
          title="Total Shorts"
          value={stats.shorts}
          icon={<ShortsIcon />}
        />
        <StatCard
          title="Total E-Papers"
          value={stats.epapers}
          icon={<NewspaperIcon />}
        />
      </div>
      <div className="mt-8 bg-white p-4 sm:p-6 rounded-lg shadow-md">
        <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-4">
          Recent Articles
        </h2>
        {articles && articles.length > 0 ? (
          <div className="space-y-4">
            {articles.map((article) => {
              const authorName =
                allUsers.find((u) => u.id == article.userId)?.username ||
                `ID: ${article.userId}`;
              return (
                <div key={article.id} className="border-b pb-2 last:border-b-0">
                  <h3 className="font-semibold text-gray-800">
                    {article.title}
                  </h3>
                  <p className="text-sm text-gray-500">
                    By {authorName} on {formatAdminArticleDate(article)}
                  </p>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-gray-600">No recent articles found.</p>
        )}
      </div>
    </div>
  );
};

// --- MultiSelect Category Component ---
const categoryOptions = [
  { value: "worldnews", label: "World News" },
  { value: "sportsnews", label: "Sports News" },
  { value: "localnews", label: "Local News" },
  { value: "business", label: "Business" },
  { value: "entertainment", label: "Entertainment" },
  { value: "technology", label: "Technology" },
  { value: "india", label: "India" },
  { value: "gujarat", label: "Gujarat" },
  { value: "e-paper", label: "E-Paper" },
  { value: "other", label: "Other" },
];

const MultiCategorySelector = ({ selectedCategories, onCategoryChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleCheckboxChange = (categoryValue) => {
    onCategoryChange(categoryValue);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative" ref={dropdownRef}>
      <label className="block text-gray-700 text-sm font-bold mb-2">
        Category
      </label>
      <div
        className="shadow-sm appearance-none border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500 min-h-[40px] flex items-center flex-wrap gap-2 cursor-pointer"
        onClick={handleToggle}
      >
        {selectedCategories.length === 0 && (
          <span className="text-gray-400">Select Categories</span>
        )}
        {selectedCategories.map((categoryValue) => {
          const categoryLabel =
            categoryOptions.find((c) => c.value === categoryValue)?.label ||
            categoryValue;
          return (
            <span
              key={categoryValue}
              className="bg-red-100 text-red-800 text-xs font-semibold px-2.5 py-1 rounded-full flex items-center"
            >
              {categoryLabel}
              <button
                type="button"
                className="ml-2 text-red-600 hover:text-red-800"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCheckboxChange(categoryValue);
                }}
              >
                &times;
              </button>
            </span>
          );
        })}
      </div>

      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
          {categoryOptions.map((option) => (
            <label
              key={option.value}
              className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
            >
              <input
                type="checkbox"
                checked={selectedCategories.includes(option.value)}
                onChange={() => handleCheckboxChange(option.value)}
                className="h-4 w-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
              />
              <span className="ml-3 text-sm text-gray-700">{option.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};
// Add this Users component after the CrudManager component and before the main App component

const Users = ({ allUsers, currentUser, setNotification }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    newPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const openEditModal = (user) => {
    if (user.id !== currentUser.id) return;
    setEditingUser(user);
    setFormData({
      username: user.username || '',
      email: user.email || '',
      newPassword: '',
    });
    setValidationErrors({});
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditingUser(null);
    setFormData({
      username: '',
      email: '',
      newPassword: '',
    });
    setValidationErrors({});
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear validation error for this field
    setValidationErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const errors = {};
    
    // Validate username
    if (formData.username) {
      if (formData.username.length < 5 || formData.username.length > 20) {
        errors.username = 'Username must be between 5 and 20 characters';
      } else if (!/^[a-zA-Z0-9]+$/.test(formData.username)) {
        errors.username = 'Username can only contain letters and numbers (no spaces or special characters)';
      }
    }
    
    // Validate email
    if (formData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        errors.email = 'Please enter a valid email address (e.g., user@example.com)';
      }
    }
    
    // Validate password
    if (formData.newPassword) {
      if (formData.newPassword.length < 8) {
        errors.newPassword = 'Password must be at least 8 characters long';
      } else if (formData.newPassword.length > 100) {
        errors.newPassword = 'Password is too long (maximum 100 characters)';
      }
    }
    
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!validateForm()) {
      setNotification({ 
        type: 'error', 
        message: 'Please fix the errors in the form before submitting' 
      });
      return;
    }
    
    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');
      
      if (!token) {
        setNotification({ 
          type: 'error', 
          message: 'You are not logged in. Please log in again.' 
        });
        setLoading(false);
        return;
      }
      
      // Build payload - only include fields that have values
      const payload = {};
      
      // Always include username and email if changed
      if (formData.username && formData.username !== currentUser.username) {
        payload.username = formData.username.trim();
      }
      
      if (formData.email && formData.email !== currentUser.email) {
        payload.email = formData.email.trim();
      }

      // Include new password if provided
      if (formData.newPassword && formData.newPassword.trim()) {
        payload.newPassword = formData.newPassword;
      }

      // Check if there's anything to update
      if (Object.keys(payload).length === 0) {
        setNotification({ type: 'info', message: 'No changes were made' });
        setLoading(false);
        return;
      }

      // Use API config to build URL
      const url = getApiUrl('UPDATE_USER', { userId: editingUser.id });

      console.log('Sending update request to:', url);
      console.log('Payload:', payload);

      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log('Response:', data);

      if (response.ok) {
        setNotification({ 
          type: 'success', 
          message: data.message || 'Your profile has been updated successfully!' 
        });
        
        // Update local storage with new user data
        const updatedUser = { 
          ...currentUser, 
          username: payload.username || currentUser.username, 
          email: payload.email || currentUser.email 
        };
        localStorage.setItem('adminUser', JSON.stringify(updatedUser));
        
        closeEditModal();
        // Reload to refresh the user list
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        // Handle specific error cases
        let errorMessage = 'Failed to update profile';
        
        if (response.status === 400) {
          errorMessage = data.message || 'Invalid input. Please check your data and try again.';
        } else if (response.status === 403) {
          errorMessage = 'You do not have permission to update this profile.';
        } else if (response.status === 404) {
          errorMessage = 'User not found. Please refresh and try again.';
        } else if (response.status === 500) {
          errorMessage = 'Server error occurred. Please try again later or contact support.';
        } else {
          errorMessage = data.message || 'An unexpected error occurred. Please try again.';
        }
        
        setNotification({ 
          type: 'error', 
          message: errorMessage
        });
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      
      let errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
      
      if (error.message.includes('Failed to fetch')) {
        errorMessage = 'Network error: Cannot reach the server. Please check if the server is running.';
      } else if (error.name === 'TypeError') {
        errorMessage = 'A technical error occurred. Please refresh the page and try again.';
      }
      
      setNotification({ 
        type: 'error', 
        message: errorMessage
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6">Users</h1>
      
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-red-700">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Username
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Email
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Role
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Created At
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {allUsers && allUsers.length > 0 ? (
                allUsers.map((user) => (
                  <tr key={user.id} className={user.id === currentUser.id ? 'bg-yellow-50' : ''}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900">{user.username}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-500">{user.email}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                        Admin
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {new Date(user.createdAt).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      {user.id === currentUser.id ? (
                        <button
                          onClick={() => openEditModal(user)}
                          className="text-indigo-600 hover:text-indigo-900"
                        >
                          Edit Profile
                        </button>
                      ) : (
                        <span className="text-gray-400">No Access</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Edit Modal */}
      {isEditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
              <h2 className="text-xl font-bold text-gray-800">Edit Profile</h2>
              <button
                onClick={closeEditModal}
                className="text-gray-500 hover:text-gray-700"
                aria-label="Close modal"
              >
                <CloseIcon />
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Username <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleFormChange}
                  className={`shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 ${
                    validationErrors.username ? 'border-red-500 focus:ring-red-500' : 'focus:ring-yellow-500'
                  }`}
                  required
                />
                {validationErrors.username && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.username}</p>
                )}
                {!validationErrors.username && (
                  <p className="text-xs text-gray-500 mt-1">5-20 characters, letters and numbers only</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleFormChange}
                  className={`shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 ${
                    validationErrors.email ? 'border-red-500 focus:ring-red-500' : 'focus:ring-yellow-500'
                  }`}
                  required
                />
                {validationErrors.email && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.email}</p>
                )}
              </div>

              <div className="pt-4 border-t">
                <p className="text-sm text-gray-600 mb-3 font-semibold">Change Password (Optional)</p>
                <p className="text-xs text-gray-500 mb-3">Leave blank to keep current password</p>
                
                <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
                  <div className="flex items-center">
                    <svg className="h-5 w-5 text-blue-600 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                    <div>
                      <span className="text-sm text-blue-800 font-medium">
                        Your password is encrypted and secure
                      </span>
                      <p className="text-xs text-blue-600 mt-1">
                        Only you can change your password - no verification needed
                      </p>
                    </div>
                  </div>
                </div>

                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    New Password
                  </label>
                  <div className="relative">
                    <input
                      type={showNewPassword ? 'text' : 'password'}
                      name="newPassword"
                      value={formData.newPassword}
                      onChange={handleFormChange}
                      placeholder="Enter new password (if changing)"
                      className={`shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 ${
                        validationErrors.newPassword ? 'border-red-500 focus:ring-red-500' : 'focus:ring-yellow-500'
                      }`}
                    />
                    <button
                      type="button"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      className="absolute right-2 top-2 text-gray-500 hover:text-gray-800"
                      aria-label={showNewPassword ? 'Hide password' : 'Show password'}
                    >
                      <EyeIcon open={showNewPassword} />
                    </button>
                  </div>
                  {validationErrors.newPassword && (
                    <p className="text-red-500 text-xs mt-1">{validationErrors.newPassword}</p>
                  )}
                  {!validationErrors.newPassword && (
                    <p className="text-xs text-gray-500 mt-1">Minimum 8 characters (leave blank to keep current)</p>
                  )}
                </div>
              </div>

              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={closeEditModal}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-red-700 text-white rounded hover:bg-red-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="flex items-center">
                      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Updating...
                    </span>
                  ) : 'Update Profile'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};
// Generic CRUD Component for Articles
const CrudManager = ({
  title,
  items,
  setItems,
  user,
  icon,
  allUsers = [],
  setNotification,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [formData, setFormData] = useState({});
  const [imageFiles, setImageFiles] = useState([]);
  const imageInputRef = useRef();
  const [viewingImage, setViewingImage] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(null);

  // This effect specifically manages the document title when the modal is open.
  useEffect(() => {
    const originalPageTitle = document.title;
    const titleSuffix =
      " | Ahmedabad Post: અમદાવાદના તાજા ગુજરાતી સમાચાર, ગુજરાત અને દેશ-દુનિયા Live સમાચાર";

    if (isModalOpen) {
      if (currentItem) {
        const itemTitle = currentItem.title || "Item";
        document.title = `Edit: ${
          itemTitle.length > 30 ? itemTitle.substring(0, 30) + "..." : itemTitle
        }${titleSuffix}`;
      } else {
        document.title = `Add New Article${titleSuffix}`;
      }
    }

    return () => {
      if (isModalOpen) {
        document.title = originalPageTitle;
      }
    };
  }, [isModalOpen, currentItem]);

  const openModal = (item = null) => {
    setCurrentItem(item);
    const initialFormData = {
      categories: [],
      title: "",
      content: "",
      youtubeUrl: "",
      shortVideo: "",
    };

    if (item) {
      let parsedCategories = [];
      if (typeof item.categories === "string") {
        try {
          parsedCategories = JSON.parse(item.categories);
        } catch (e) {
          console.error(
            "Failed to parse categories JSON string:",
            item.categories
          );
          parsedCategories = [item.categories];
        }
      } else if (Array.isArray(item.categories)) {
        parsedCategories = item.categories;
      }

      const mappedData = {
        ...item,
        categories: parsedCategories,
        shortVideo: item.shortVideo || item.shortsVideo || "",
        // Populate editor with star-markup when possible (convert <strong> to *text*)
        content: htmlToEditorText(item.content || ""),
      };

      setFormData(mappedData);

      const currentImages = Array.isArray(item.image)
        ? item.image.filter((img) => img).map((img) => img.replace(/"/g, ""))
        : [];
      setImageFiles(currentImages);
    } else {
      setFormData(initialFormData);
      setImageFiles([]);
    }

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentItem(null);
    setImageFiles([]);
  };

  const handleCategoryChange = (categoryValue) => {
    setFormData((prev) => {
      const currentCategories = prev.categories || [];
      const newCategories = currentCategories.includes(categoryValue)
        ? currentCategories.filter((c) => c !== categoryValue)
        : [...currentCategories, categoryValue];
      return { ...prev, categories: newCategories };
    });
  };

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "images") {
      const selectedFiles = Array.from(files);
      setImageFiles((prev) => {
        // Filter out duplicates by comparing file names and sizes
        const existingFiles = prev.filter((f) => typeof f === "string" || f instanceof File);
        const allFiles = [...existingFiles, ...selectedFiles];
        // Remove duplicates (by name and size)
        const uniqueFiles = [];
        const fileMap = new Map();
        allFiles.forEach((file) => {
          if (typeof file === "string") {
            if (!fileMap.has(file)) {
              fileMap.set(file, true);
              uniqueFiles.push(file);
            }
          } else if (file instanceof File) {
            const key = file.name + file.size;
            if (!fileMap.has(key)) {
              fileMap.set(key, true);
              uniqueFiles.push(file);
            }
          }
        });
        return uniqueFiles;
      });
      // Clear the file input so user can select more images one by one
      if (imageInputRef.current) {
        imageInputRef.current.value = "";
      }
    } else if (name === "pdfFile") {
      setFormData((prev) => ({
        ...prev,
        pdfFile: files && files[0] ? files[0] : null,
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Preview HTML for content with *stars* converted to bold
  const [contentPreview, setContentPreview] = useState("");

  useEffect(() => {
    setContentPreview(convertStarsToHtml(formData.content || ""));
  }, [formData.content]);

  const handleRemoveImage = (idx) => {
    const fileToRemove = imageFiles[idx];
    const updatedFiles = imageFiles.filter((_, i) => i !== idx);
    setImageFiles(updatedFiles);

    if (fileToRemove instanceof File && imageInputRef.current) {
      const dataTransfer = new DataTransfer();
      updatedFiles.forEach((file) => {
        if (file instanceof File) {
          dataTransfer.items.add(file);
        }
      });
      imageInputRef.current.files = dataTransfer.files;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("adminToken");
    const formDataToSend = new FormData();

    Object.keys(formData).forEach((key) => {
      if (
        ![
          "image",
          "pdf",
          "pdfFile",
          "categories",
          "createdAt",
          "updatedAt",
          "id",
          "slug",
        ].includes(key)
      ) {
        // If this is the main content field, send the preview HTML (convert *stars* -> <strong>)
        if (key === "content") {
          const raw = formData.content || "";
          // If content already contains HTML tags, assume it's HTML and send as-is
          const contentHtml = /<[^>]+>/g.test(raw)
            ? raw
            : convertStarsToHtml(raw);
          formDataToSend.append("content", contentHtml);
        } else {
          formDataToSend.append(key, formData[key] || "");
        }
      }
    });

    if (formData.categories && Array.isArray(formData.categories)) {
      formDataToSend.append("categories", JSON.stringify(formData.categories));
    }

    imageFiles.forEach((file) => {
      if (file instanceof File) {
        formDataToSend.append("image", file);
      }
    });

    if (formData.pdfFile instanceof File) {
      formDataToSend.append("pdf", formData.pdfFile);
    }

    if (currentItem) {
      // UPDATE LOGIC
      try {
        const initialImageUrls = currentItem.image
          ? currentItem.image
              .filter((img) => img)
              .map((img) => img.replace(/"/g, ""))
          : [];
        const finalImageUrls = imageFiles.filter(
          (file) => typeof file === "string"
        );
        const deletedImages = initialImageUrls
          .filter((url) => !finalImageUrls.includes(url))
          .map((url) => url.split("/").pop());

        if (deletedImages.length > 0) {
          formDataToSend.append("deleteImages", JSON.stringify(deletedImages));
        }

        const res = await fetch(
          getApiUrl('UPDATE_NEWS', { id: currentItem.id }),
          {
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            body: formDataToSend,
          }
        );

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.message || "Failed to update article.");
        }

        setItems(
          items.map((item) => (item.id === currentItem.id ? data.post : item))
        );
        setNotification({
          message: "Article updated successfully!",
          type: "success",
        });
        try {
          const channel = new BroadcastChannel('articles-update');
          channel.postMessage({ updated: true });
          channel.close();
        } catch (e) {
          console.error('BroadcastChannel is not supported in this browser.');
        }
        closeModal();
      } catch (error) {
        console.error("Update failed:", error);
        setNotification({ message: error.message, type: "error" });
      }
    } else {
      // CREATE LOGIC
      try {
        const res = await fetch(getApiUrl('CREATE_NEWS'), {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formDataToSend,
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.message || "Failed to create article.");
        }

        setItems((prevItems) => [data.post, ...prevItems]);
        setNotification({
          message: "Article created successfully!",
          type: "success",
        });
        try {
          const channel = new BroadcastChannel('articles-update');
          channel.postMessage({ updated: true });
          channel.close();
        } catch (e) {
          console.error('BroadcastChannel is not supported in this browser.');
        }
        closeModal();
      } catch (error) {
        console.error("Create failed:", error);
        setNotification({ message: error.message, type: "error" });
      }
    }
  };

  const handleDelete = (id) => {
    setDeleteConfirmation(id);
  };

  const confirmDelete = async () => {
    if (!deleteConfirmation) return;
    const id = deleteConfirmation;
    try {
      const token = localStorage.getItem("adminToken");
      const res = await fetch(getApiUrl('DELETE_NEWS', { id }), {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to delete article.");
      }

      setItems(items.filter((item) => item.id !== id));
      setNotification({
        message: "Article deleted successfully!",
        type: "success",
      });
      try {
        const channel = new BroadcastChannel('articles-update');
        channel.postMessage({ updated: true });
        channel.close();
      } catch (e) {
        console.error('BroadcastChannel is not supported in this browser.');
      }
    } catch (error) {
      console.error("Delete failed:", error);
      setNotification({ message: error.message, type: "error" });
    } finally {
      setDeleteConfirmation(null);
    }
  };

  const canEdit = () => user.isAdmin === true;

  return (
    <div>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        <h1 className="text-2xl font-bold text-gray-800 flex items-center">
          {icon} {title}
        </h1>
        <button
          onClick={() => openModal()}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-1.5 px-4 rounded-lg shadow text-sm transition-colors duration-300 w-full sm:w-auto"
        >
          Add New {title.slice(0, -1)}
        </button>
      </div>

      {/* Desktop Table View */}
      <div className="hidden md:block bg-white shadow-md rounded-lg border border-gray-100">
        <div className="w-full overflow-x-auto">
          <table className="min-w-[900px] w-full table-fixed divide-y divide-gray-200 text-xs md:text-sm lg:text-base">
            <thead className="bg-red-700">
              <tr>
                <th
                  scope="col"
                  className="px-2 md:px-4 lg:px-6 py-2 md:py-3 text-left font-medium text-white uppercase tracking-wider w-2/6 md:w-2/6 lg:w-2/6"
                >
                  Title
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-4 lg:px-6 py-2 md:py-3 text-left font-medium text-white uppercase tracking-wider w-1/6 md:w-1/6 lg:w-1/6"
                >
                  Category
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-4 lg:px-6 py-2 md:py-3 text-left font-medium text-white uppercase tracking-wider w-1/6 md:w-1/6 lg:w-1/6"
                >
                  Author
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-4 lg:px-6 py-2 md:py-3 text-left font-medium text-white uppercase tracking-wider w-1/6 md:w-1/6 lg:w-1/6"
                >
                  Published Date
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-4 lg:px-6 py-2 md:py-3 text-center font-medium text-white uppercase tracking-wider w-1/6 md:w-1/6 lg:w-1/6"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-red-50 divide-y divide-gray-200">
              {items.map((item) => (
                <tr key={item.id} className="hover:bg-red-100 transition-colors">
                  <td className="px-2 md:px-4 lg:px-6 py-2 md:py-4 font-medium text-gray-900 break-words max-w-[120px] md:max-w-[180px] lg:max-w-[240px] truncate">
                    <span title={item.title}>{item.title}</span>
                  </td>
                  <td className="px-2 md:px-4 lg:px-6 py-2 md:py-4 text-gray-500 break-words max-w-[80px] md:max-w-[120px] lg:max-w-[180px] truncate">
                    <span title={Array.isArray(item.categories) ? item.categories.join(', ') : JSON.parse(item.categories || '[]').join(', ')}>
                      {Array.isArray(item.categories)
                        ? item.categories.join(", ")
                        : JSON.parse(item.categories || "[]").join(", ")}
                    </span>
                  </td>
                  <td className="px-2 md:px-4 lg:px-6 py-2 md:py-4 text-blue-700 font-semibold max-w-[80px] md:max-w-[120px] lg:max-w-[180px] truncate">
                    <span title={allUsers.find((u) => u.id == item.userId)?.username || `ID: ${item.userId}`}>
                      {allUsers.find((u) => u.id == item.userId)?.username ||
                        `ID: ${item.userId}`}
                    </span>
                  </td>
                  <td className="px-2 md:px-4 lg:px-6 py-2 md:py-4 text-gray-500 max-w-[80px] md:max-w-[120px] lg:max-w-[180px] truncate">
                    <span title={item.publishedDate || item.date || new Date(item.createdAt).toLocaleString("en-US")}>
                      {item.publishedDate ? new Date(item.publishedDate).toLocaleDateString("en-GB") : (item.date ? item.date : new Date(item.createdAt).toLocaleDateString("en-GB"))}
                    </span>
                  </td>
                  
                  <td className="px-2 md:px-4 lg:px-6 py-2 md:py-4 font-medium">
                    {canEdit() ? (
                      <div className="flex items-center justify-center space-x-1 md:space-x-2">
                        <button
                          onClick={() => openModal(item)}
                          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 md:px-3 rounded-lg shadow transition-colors duration-200 text-xs md:text-sm"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(item.id)}
                          className="bg-red-500 hover:bg-red-600 text-white font-bold py-1 px-2 md:px-3 rounded-lg shadow transition-colors duration-200 text-xs md:text-sm"
                        >
                          Delete
                        </button>
                      </div>
                    ) : (
                      <span className="text-gray-400 text-xs">Read-only</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Card View */}
      <div className="block md:hidden space-y-4">
        {items.map((item) => (
          <div
            key={item.id}
            className="bg-white p-4 rounded-lg shadow-md border border-gray-100 flex flex-col space-y-3"
          >
            <div>
              <h3 className="font-bold text-gray-800 break-words">
                {item.title}
              </h3>
            </div>
            <div className="text-sm text-gray-600 space-y-1">
              <p>
                <span className="font-semibold">Category: </span>
                {Array.isArray(item.categories)
                  ? item.categories.join(", ")
                  : JSON.parse(item.categories || "[]").join(", ")}
              </p>
              <p>
                <span className="font-semibold">Author: </span>
                <span className="text-blue-700">
                  {allUsers.find((u) => u.id == item.userId)?.username ||
                    `ID: ${item.userId}`}
                </span>
              </p>
              <p>
                <span className="font-semibold">Published: </span>
                {item.publishedDate ? new Date(item.publishedDate).toLocaleString("en-US", { year: '2-digit', month: '2-digit', day: '2-digit' }) : (item.date ? item.date : new Date(item.createdAt).toLocaleString("en-US", { year: '2-digit', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric', hour12: true }))}
              </p>
            </div>
            {canEdit() && (
              <div className="flex items-center justify-end space-x-3 border-t pt-3 mt-2">
                <button
                  onClick={() => openModal(item)}
                  className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1.5 px-4 rounded-lg shadow transition-colors duration-200 text-sm"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(item.id)}
                  className="bg-red-500 hover:bg-red-600 text-white font-bold py-1.5 px-4 rounded-lg shadow transition-colors duration-200 text-sm"
                >
                  Delete
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl flex flex-col">
            <div className="flex justify-between items-center p-4 sm:p-6 border-b">
              <h2 className="text-xl font-bold">
                {currentItem ? "Edit" : "Add"} {title.slice(0, -1)}
              </h2>
              <button
                onClick={closeModal}
                className="p-1 rounded-full hover:bg-gray-200"
              >
                <CloseIcon />
              </button>
            </div>
            <form
              onSubmit={handleSubmit}
              className="p-4 sm:p-6 overflow-y-auto"
              style={{ maxHeight: "calc(100vh - 150px)" }}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
                <div className="md:col-span-1">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="title"
                  >
                    Title
                  </label>
                  <input
                    id="title"
                    name="title"
                    type="text"
                    value={formData.title || ""}
                    onChange={handleFormChange}
                    className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                    required
                  />
                </div>
                <div className="md:col-span-1">
                  <MultiCategorySelector
                    selectedCategories={formData.categories || []}
                    onCategoryChange={handleCategoryChange}
                  />
                </div>
                <div className="md:col-span-2">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="content"
                  >
                    Content
                  </label>
                  <textarea
                    id="content"
                    name="content"
                    value={formData.content || ""}
                    onChange={handleFormChange}
                    className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                    rows={4}
                    required
                  />
                  <div className="mt-3">
                    <label className="block text-gray-700 text-sm font-bold mb-2">Preview</label>
                    <div
                      className="prose max-w-none p-3 border rounded bg-white text-gray-800"
                      dangerouslySetInnerHTML={{
                        __html: (function() {
                          const raw = formData.content || "";
                          // If the content already contains HTML tags, render as-is.
                          if (/<[^>]+>/g.test(raw)) return raw;
                          return convertStarsToHtml(raw);
                        })()
                      }}
                    />
                  </div>
                </div>
                <div className="md:col-span-1">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="youtubeUrl"
                  >
                    YouTube URL
                  </label>
                  <input
                    id="youtubeUrl"
                    name="youtubeUrl"
                    type="url"
                    value={formData.youtubeUrl || ""}
                    onChange={handleFormChange}
                    className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  />
                  {currentItem && formData.youtubeUrl && (
                    <div className="mt-2 text-xs text-gray-600">
                      Current:{" "}
                      <a
                        href={formData.youtubeUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline break-all"
                      >
                        {formData.youtubeUrl}
                      </a>
                    </div>
                  )}
                </div>
                <div className="md:col-span-1">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="reference_url"
                  >
                    Reference URL
                  </label>
                  <input
                    id="reference_url"
                    name="reference_url"
                    type="url"
                    value={formData.reference_url || ""}
                    onChange={handleFormChange}
                    placeholder="https://source.example.com/article"
                    className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  />
                  {currentItem && formData.reference_url && (
                    <div className="mt-2 text-xs text-gray-600">
                      Current: {" "}
                      <a
                        href={formData.reference_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline break-all"
                      >
                        {formData.reference_url}
                      </a>
                    </div>
                  )}
                </div>
                <div className="md:col-span-1">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="embedUrl"
                  >
                    Embed Post URL (X / Instagram)
                  </label>
                  <input
                    id="embedUrl"
                    name="embedUrl"
                    type="url"
                    value={formData.embedUrl || ""}
                    onChange={handleFormChange}
                    placeholder="https://x.com/user/status/12345 or https://www.instagram.com/p/xxxxx/"
                    className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  />
                  {currentItem && formData.embedUrl && (
                    <div className="mt-2 text-xs text-gray-600">
                      Current: {" "}
                      <a
                        href={formData.embedUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline break-all"
                      >
                        {formData.embedUrl}
                      </a>
                    </div>
                  )}
                </div>
                <div className="md:col-span-1">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="shortVideo"
                  >
                    Shorts Video URL
                  </label>
                  <input
                    id="shortVideo"
                    name="shortVideo"
                    type="url"
                    value={formData.shortVideo || ""}
                    onChange={handleFormChange}
                    className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  />
                  {currentItem && formData.shortVideo && (
                    <div className="mt-2 text-xs text-gray-600">
                      Current:{" "}
                      <a
                        href={formData.shortVideo}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline break-all"
                      >
                        {formData.shortVideo}
                      </a>
                    </div>
                  )}
                </div>
                <div className="md:col-span-1">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="date"
                  >
                    Published Date
                  </label>
                  <DatePicker
                    value={formData.date || ""}
                    onChange={(val) => setFormData((p) => ({ ...p, date: val }))}
                    placeholder="dd/mm/yyyy"
                  />
                  <div className="mt-1 text-xs text-gray-500">You can type dd/mm/yyyy or pick from calendar</div>
                </div>
                <div className="md:col-span-1">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="pdfFile"
                  >
                    PDF Upload
                  </label>
                  <input
                    id="pdfFile"
                    name="pdfFile"
                    type="file"
                    accept="application/pdf"
                    onChange={handleFormChange}
                    className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  />
                  {currentItem && formData.pdf && (
                    <div className="mt-2 text-xs text-gray-600">
                      Current:{" "}
                      <a
                        href={formData.pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        {formData.pdf.split("/").pop()}
                      </a>
                    </div>
                  )}
                </div>
                <div className="md:col-span-1">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="images"
                  >
                    Image Upload (max 5)
                  </label>
                  {/* Hidden file input */}
                  <input
                    ref={imageInputRef}
                    id="images"
                    name="images"
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleFormChange}
                    style={{ display: "none" }}
                  />
                  <button
                    type="button"
                    className="appearance-none border border-gray-300 rounded w-full py-2 px-3 text-gray-700 bg-white leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500 text-left mt-2 transition-colors duration-200 hover:bg-gray-50 cursor-pointer"
                    onClick={() => {
                      if (imageInputRef.current) imageInputRef.current.click();
                    }}
                  >
                    + Add Image
                  </button>
                </div>
                <div className="md:col-span-2">
                  {imageFiles.length > 0 && (
                    <>
                      <label className="block text-gray-700 text-sm font-bold mb-2">
                        Image Previews
                      </label>
                      <div className="mt-2 flex flex-wrap gap-4 items-center p-2 border rounded-md bg-gray-50">
                        {imageFiles.map((file, idx) => {
                          if (!file) return null;
                          const isUrl = typeof file === "string";
                          const src = isUrl ? file : URL.createObjectURL(file);
                          return (
                            <div
                              key={idx}
                              className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-lg overflow-hidden shadow-md group"
                            >
                              <img
                                src={src}
                                alt={`preview ${idx}`}
                                className="w-full h-full object-cover"
                              />
                              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-all duration-300 flex items-center justify-center space-x-2">
                                <button
                                  type="button"
                                  onClick={() => setViewingImage(src)}
                                  className="transform scale-0 group-hover:scale-100 transition-transform duration-200 bg-blue-600/80 hover:bg-blue-700 text-white rounded-full w-8 h-8 flex items-center justify-center"
                                  title="View"
                                >
                                  <ViewIcon />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleRemoveImage(idx)}
                                  className="transform scale-0 group-hover:scale-100 transition-transform duration-200 bg-red-600/80 hover:bg-red-700 text-white rounded-full w-8 h-8 flex items-center justify-center"
                                  title="Remove"
                                >
                                  <CloseIcon />
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="flex justify-end mt-6 pt-4 border-t">
                <button
                  type="button"
                  onClick={closeModal}
                  className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded-lg mr-2"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-lg"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {viewingImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 z-[100] flex justify-center items-center p-4"
          onClick={() => setViewingImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 z-[101]"
            onClick={() => setViewingImage(null)}
          >
            <CloseIcon />
          </button>
          <img
            src={viewingImage}
            alt="Full size preview"
            className="max-w-full max-h-full rounded-lg shadow-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
      {deleteConfirmation && (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-[100] flex justify-center items-center p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md flex flex-col">
            <div className="p-6 text-center">
              <h3 className="text-lg font-bold text-gray-800 mb-2">
                Confirm Deletion
              </h3>
              <p className="text-sm text-gray-600 mb-6">
                Are you sure you want to delete this article? This action cannot
                be undone.
              </p>
              <div className="flex justify-center gap-4">
                <button
                  type="button"
                  onClick={() => setDeleteConfirmation(null)}
                  className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-6 rounded-lg"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={confirmDelete}
                  className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-6 rounded-lg"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// --- MAIN APP COMPONENT ---
export default function App() {
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState("dashboard");
  const [notification, setNotification] = useState(null);
  const [showSignup, setShowSignup] = useState(false);
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  const [articles, setArticles] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [stats, setStats] = useState({
    articles: 0,
    videos: 0,
    shorts: 0,
    epapers: 0,
  });

  // Store the original public title to revert to on logout
  const [originalTitle, setOriginalTitle] = useState("");
  useEffect(() => {
    setOriginalTitle(document.title);
  }, []);

  const handleLogout = (isUnauthorized = false) => {
    setUser(null);
    setCurrentPage("dashboard");
    localStorage.removeItem("adminUser");
    localStorage.removeItem("adminToken");
    const message = isUnauthorized
      ? "Your session has expired. Please log in again."
      : "You have been logged out.";
    setNotification({ message, type: isUnauthorized ? "error" : "success" });
  };

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("adminUser");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (error) {
      console.error("Failed to parse stored user:", error);
      localStorage.removeItem("adminUser");
    }
    // If adminUser exists but no token, expire session
    const token = localStorage.getItem("adminToken");
    if (localStorage.getItem("adminUser") && !token) {
      handleLogout(true);
    }
    setIsAuthLoading(false);
  }, []);

  // Listen for storage events (other tabs) — if token or user changes elsewhere, expire session here
  useEffect(() => {
    const onStorage = (e) => {
      try {
        if (e.key === "adminToken") {
          const currentToken = localStorage.getItem("adminToken");
          // If token was removed or changed to something that doesn't match this tab's idea, expire session
          if (!currentToken) {
            // token removed elsewhere
            handleLogout(true);
          }
        }
        if (e.key === "adminUser") {
          const newVal = e.newValue;
          if (!newVal) {
            // user removed elsewhere
            handleLogout(true);
            return;
          }
          const parsed = JSON.parse(newVal);
          // If another user logged in (different id), expire this session
          if (!user || (parsed && parsed.id !== user.id)) {
            handleLogout(true);
          }
        }
      } catch (err) {
        console.error('Storage event handling failed', err);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [user]);

  // Fetch admin users and articles
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("adminToken");
        if (!token) {
          console.warn("No token found.");
          return;
        }

        // Fetch admin users using API config
        const usersUrl = getApiUrl('GET_ADMIN_USERS');
        const usersRes = await fetch(usersUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        if (usersRes.ok) {
          const usersData = await usersRes.json();
          console.log('Admin users fetched:', usersData);
          setAllUsers(usersData.users || []);
        } else {
          console.error('Failed to fetch admin users:', usersRes.status);
        }

        // Fetch articles using API config
        const articlesUrl = getApiUrl('GET_NEWS');
        const articlesRes = await fetch(articlesUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        if (articlesRes.ok) {
          const articlesData = await articlesRes.json();
          const fetchedArticles = articlesData.posts || [];
          setArticles(fetchedArticles); // Fixed: was setAllArticles

          // Calculate stats
          const totalArticles = fetchedArticles.length;
          const totalVideos = fetchedArticles.filter((a) => a.youtubeUrl).length;
          const totalShorts = fetchedArticles.filter((a) => a.shortVideo || a.shortsVideo).length;
          const totalEpapers = fetchedArticles.filter((a) => a.pdf).length;

          setStats({
            articles: totalArticles,
            videos: totalVideos,
            shorts: totalShorts,
            epapers: totalEpapers,
          });
        } else {
          console.error('Failed to fetch articles:', articlesRes.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setNotification({
          type: "error",
          message: "Failed to load data. Please refresh the page.",
        });
      }
    };

    if (user && user.isAdmin) {
      fetchData();
    }
  }, [user]);

  // Fetch all users for the articles table
  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (user && user.isAdmin && token) {
      fetch(getApiUrl('GET_USERS'), {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if ([401, 403].includes(res.status)) {
            handleLogout(true);
            throw new Error("Session expired");
          }
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          const users = data.users || [];
          // Don't overwrite allUsers, merge or use for validation
          try {
            // If a user is stored locally, ensure they still exist on the server and are admin
            const stored = localStorage.getItem('adminUser');
            if (stored) {
              const parsed = JSON.parse(stored);
              const found = users.find((u) => u.id === parsed.id || u.email === parsed.email);
              if (!found || !found.isAdmin) {
                // user not present on the server or lost admin privileges -> expire session
                handleLogout(true);
                return;
              }
            }
          } catch (err) {
            console.error('User validation after GET_USERS failed', err);
          }
        })
        .catch((err) => {
          console.error("Error fetching users:", err.message);
          if (err.message !== "Session expired") {
            setNotification({
              message: "Failed to fetch users.",
              type: "error",
            });
          }
        });
    }
  }, [user]);

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => setNotification(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  // This effect now manages the GENERAL meta tags and title for all admin-related pages.
  useEffect(() => {
    const titleSuffix =
      " | Ahmedabad Post: અમદાવાદના તાજા ગુજરાતી સમાચાર, ગુજરાત અને દેશ-દુનિયા Live સમાચાર";
    if (user) {
      let newTitle = "Admin Panel"; // Base title
      if (currentPage === "dashboard") {
        newTitle = "Dashboard";
      } else if (currentPage === "articles") {
        newTitle = "Manage Articles";
      } else if (currentPage === "users") {
        newTitle = "Manage Users";
      }
      document.title = `${newTitle}${titleSuffix}`;

      // This ensures all admin pages have the "noindex" tag to hide them from search engines.
      let meta = document.head.querySelector('meta[name="robots"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "robots";
        document.head.appendChild(meta);
      }
      meta.content = "noindex, nofollow";

      // This cleanup function runs ONLY when the user logs out.
      return () => {
        document.title = originalTitle; // Revert to the original public title of the website.
        const metaTag = document.head.querySelector('meta[name="robots"]');
        if (metaTag) {
          document.head.removeChild(metaTag); // Remove the "noindex" tag.
        }
      };
    } else {
      // Handle meta for Login and Signup pages
      const newTitle = showSignup
        ? "Administrator Sign Up"
        : "Administrator Login";
      document.title = `${newTitle}${titleSuffix}`;

      // This ensures login/signup pages also have the "noindex" tag.
      let meta = document.head.querySelector('meta[name="robots"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "robots";
        document.head.appendChild(meta);
      }
      meta.content = "noindex, nofollow";
    }
  }, [user, currentPage, originalTitle, showSignup]); // This effect re-runs when the user logs in/out, navigates, or switches between login/signup.

  const handleLogin = (loggedInUser) => {
    localStorage.setItem("adminUser", JSON.stringify(loggedInUser));
    setUser(loggedInUser);
  };

  if (isAuthLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    if (showSignup) {
      return <Signup onSwitch={() => setShowSignup(false)} />;
    }
    return (
      <Login
        onLogin={handleLogin}
        setNotification={setNotification}
        onSwitch={() => setShowSignup(true)}
      />
    );
  }

  const renderPage = () => {
    if (user.isAdmin === true) {
      switch (currentPage) {
        case "dashboard":
          return (
            <Dashboard
              stats={stats}
              articles={articles.slice(0, 5)}
              allUsers={allUsers}
            />
          );
        case "articles":
          return (
            <CrudManager
              title="Articles"
              items={articles}
              setItems={setArticles}
              user={user}
              icon={<ArticleIcon />}
              allUsers={allUsers}
              setNotification={setNotification}
            />
          );
        case "users":
          return (
            <Users
              allUsers={allUsers}
              currentUser={user}
              setNotification={setNotification}
            />
          );
        default:
          return (
            <Dashboard
              stats={stats}
              articles={articles.slice(0, 5)}
              allUsers={allUsers}
            />
          );
      }
    }
    return <p>Access Denied. You do not have administrator privileges.</p>;
  };

  return (
    <div className="flex h-screen bg-gray-100 flex-col md:flex-row">
      {notification && (
        <div
          className={`fixed top-4 right-4 left-4 sm:left-auto sm:w-auto max-w-sm z-[100] p-4 rounded-lg shadow-lg text-white ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {notification.message}
        </div>
      )}
      <Sidebar
        user={user}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onLogout={handleLogout}
      />
      <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
        {renderPage()}
      </main>
    </div>
  );
}

// Helper to format article date in admin: prefer publishedDate, then date, then createdAt
const formatAdminArticleDate = (item) => {
  if (!item) return "";
  if (item.publishedDate) return new Date(item.publishedDate).toLocaleString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit' });
  if (item.date) {
    // if date is dd/mm/yyyy, convert to locale string
    const parts = String(item.date).split('/');
    if (parts.length === 3) {
      const [dd, mm, yyyy] = parts.map(p => parseInt(p,10));
      if (!isNaN(dd) && !isNaN(mm) && !isNaN(yyyy)) {
        return new Date(yyyy, mm-1, dd).toLocaleString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit' });
      }
    }
    return item.date;
  }
  return new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit' });
};
